module.exports = [
	{
		"html/home.html": {
			"remote": "<div>Hello</div>\n<h1>this is html/home.html file</h1>\n<footer>Bye</footer>",
			"local": "<div>Hello</div>\n<h1>this is html/home.html file but changed in middle</h1>\n<footer>Bye and see you</footer>"
		}
	},
	{
		"html/landing.html": {
			"remote": "<h1>Hi</h1>\n<div>this is html/landing.html file</div>\n<footer>Byeeee</footer>",
			"local": "<h1>Hi</h1>\n<div>this is html/landing.html file</div>\n<footer>Byeeee</footer></h2></h2>"
		}
	},
	{
		"css/blended_css/normalize/normalize/normalize/normalize/normalize/normalize.css": {
			"remote": "<h1>Hi</h1>\n<div>this is html/landing.html file</div>\n<footer>Byeeee</footer>\n<div>Hello</div>\n<h1>this is html/home.html file</h1>\n<footer>Bye</footer>",
			"local": "<h1>Hi</h1>\n<div>this is html/landing.html file</div>\n<footer>Byeeee</footer></h2></h2>"
		}
	},
	{
		"bannerimagefile1.png": {
			"remote": "<h1>Hi</h1>\n<div>this is html/landing.html file</div>\n<footer>Byeeee</footer>\n<div>Hello</div>\n<h1>this is html/home.html file</h1>\n<footer>Bye</footer>",
			"local": "<h1>Hi</h1>\n<div>this ifasdfasdfs html/landing.html file</div>\n<footer>Byeefasdfee</footer>\n<div>Hefasdfllo</div>\n<h1>this isasdfasdf html/home.html file</h1>\n<footer>asdfasdfBye</footer>\n<h1>Hi</h1>\n<div>this is html/landing.html file</div>\n<footer>Byeeee</footer>\n<div>Hello</div>\n<h1>this is html/home.html file</h1>\n<footer>Bye</footer> "
		}
	},
	{
		"myhtml/home.html": {
			"remote": "this is home.html fileee",
			"local": ""
		}
	}
];


/** WEBPACK FOOTER **
 ** ./html/stores/dataOfDiff.json
 **/